<template>
  <div class="animated fadeIn">
    <b-row class="mb-3 align-items-center">
      <b-col cols="auto">
        <b-button-group>
          <b-button
            v-for="j in jaren"
            :key="j"
            :variant="j === jaar ? 'primary' : 'outline-primary'"
            @click="jaar = j"
          >
            {{ j }}
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="5" cols="12">
        <b-table
          :items="inspecteursList"
          :fields="inspFields"
          dark
          small
          bordered
          hover
        >
          <template 
            v-for="n in 4" 
            #[`head(Q${n})`]
          >
            <a 
              :key="`head-${n}`"
              href="#" 
              class="text-white text-decoration-none" 
              @click.prevent="kwartaal = n"
            >
              Q{{ n }}
            </a>
          </template>
          <template 
            v-for="n in 4" 
            #[`cell(Q${n})`]="{ item }"
          >
            <b-progress 
              :key="n"
              :max="144" 
              height="8px"
              class="mb-1"
            >
              <b-progress-bar 
                :value="item[`Q${n}`].CLOSED" 
                variant="success" 
              />
              <b-progress-bar 
                :value="item[`Q${n}`].AUDIT" 
                variant="info" 
              />
              <b-progress-bar 
                :value="item[`Q${n}`].OPEN" 
                variant="warning" 
              />
            </b-progress>
            <div 
              v-if="n === kwartaal" 
              :key="`counts-${n}`"
              class="d-flex justify-content-between mt-1"
            >
              <b-badge 
                href="#" 
                variant="warning" 
                class="flex-fill mx-1 py-1" 
                @click.prevent="getDetails({ id: item.id, kwartaal: n, status: 'OPEN', jaar: jaar })"
              >
                {{ item[`Q${n}`].OPEN }}
              </b-badge>
              <b-badge 
                href="#" 
                variant="info" 
                class="flex-fill mx-1 py-1" 
                @click.prevent="getDetails({ id: item.id, kwartaal: n, status: 'AUDIT', jaar: jaar })"
              >
                {{ item[`Q${n}`].AUDIT }}
              </b-badge>
              <b-badge 
                href="#" 
                variant="success" 
                class="flex-fill mx-1 py-1" 
                @click.prevent="getDetails({ id: item.id, kwartaal: n, status: 'CLOSED', jaar: jaar })"
              >
                {{ item[`Q${n}`].CLOSED }}
              </b-badge>
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col lg="7" cols="12">
        <b-card 
          v-if="detailsTitel" 
          no-body
        >
          <b-card-header>
            <strong>{{ detailsTitel }}</strong>
          </b-card-header>
          <b-card-body class="p-0">
            <b-table 
              :items="details"
              :fields="detailFields"
              :busy="busy"
              dark 
              small
              bordered
              primary-key="data.id"
              class="mb-0"
            >
              <template #table-busy>
                <div class="text-center text-white my-2">
                  <b-spinner class="align-middle mx-2" />
                  <strong>Laden...</strong>
                </div>
              </template>
              <template #cell(#)="row">
                {{ row.index+1 }}
              </template>
              <template #cell(Status)="row">
                <font-awesome-icon 
                  v-if="row.item.data.status === 'OPEN'" 
                  icon="square"
                />
                <font-awesome-icon 
                  v-if="row.item.data.status === 'AUDIT'" 
                  icon="check"
                />
                {{ row.item.data.status }}
              </template>
              <template 
                #cell(Datum)="row" 
              >
                <span v-if="row.item.data.datum == null">
                  {{ moment(row.item.data.deadline).fromNow() }}
                </span>
                <span v-else>
                  {{ moment(row.item.data.datum).format('L') }}
                </span>
              </template>
              <template #cell(Omschrijving)="row">
                {{ row.item.titel }}<br>
                <small>{{ row.item.data.omschrijving }}</small>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
        <div 
          v-else 
          class="text-muted text-center mt-5"
        >
          Klik op een status om details te bekijken.
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  name: 'Dashboard',
  mixins: [serviceMixin],
  data: function () {
    return {
      operationeel: [],
      details: [],
      detailsTitel: null,
      busy: false,
      jaar: new Date().getFullYear(),
      kwartaal: Math.ceil((new Date().getMonth() + 1) / 3)
    }
  },
  computed: {
    inspFields: function() {
      return [
        { key: 'naam', label: 'Inspecteur' },
        ...([1,2,3,4].map(n => ({
          key: `Q${n}`,
          label: `Q${n}`,
          thClass: n === this.kwartaal ? 'bg-secondary' : '',
          tdClass: n === this.kwartaal ? 'bg-secondary' : ''
        })))
      ]
    },
    detailFields: function() {
      return [
        '#',
        'Status',
        { key: 'data.toegewezen_aan.Naam', label: 'Inspecteur' },
        'Omschrijving',
        { key: 'Datum', label: 'Datum' }
      ]
    },
    jaren: function() {
      const set = new Set(this.operationeel.map(i => i.jaar));
      return [...set].sort((a, b) => b - a).slice(0, 3);
    },
    operationeelJaar: function() { return this.operationeel.filter((i) => i.jaar == this.jaar) },
    inspecteurs: function() {
      var insp = {};
      this.operationeelJaar.forEach(function(n) {
        if (!insp[n.id]) insp[n.id] = {
          'naam': n.naam,
          'id': n.id,
          'Q1': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
          'Q2': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
          'Q3': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
          'Q4': {'OPEN':0,'AUDIT': 0,'CLOSED': 0},
        }
        insp[n.id][`Q${n.kwartaal}`][n.status] = n.aantal
      })
      return insp;
    },
    inspecteursList: function() {
      return Object.values(this.inspecteurs);
    }
  },
  watch: {
    jaar() { this.clearDetails(); },
    kwartaal() { this.clearDetails(); }
  },
  mounted() {
    this.getOperationeel();
  },
  methods: {
    clearDetails() {
      this.details = [];
      this.detailsTitel = null;
    },
    getDetails(params) {
     var vm = this;
     this.busy = true;
     var naam = this.inspecteurs[params.id] ? this.inspecteurs[params.id].naam : '';
     this.detailsTitel = `${naam} — Q${params.kwartaal} — ${params.status}`;
      this.post('/dashboard/operationeel/details',params)
      .then(function(resp) { 
        vm.$set(vm,'details',resp.data.events);
        vm.detailsTitel = `${naam} — Q${params.kwartaal} — ${params.status} (${resp.data.events.length})`;
      })
      .catch(function(error) { console.log(error) })
      .finally(() => vm.busy = false);
    },
    getOperationeel() {
      var vm = this;
      this.get('/dashboard/operationeel')
      .then(function(resp) { vm.$set(vm,'operationeel',resp.data.operationeel); console.log(resp.data) })
      .catch(function(error) { console.log(error) });
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  }
}
</script>